import React from "react";

import ImportConfig from "@mapmycustomers/shared/types/imports/ImportConfig";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import RenameConfigModal from "./modals/RenameConfigModal";
import styles from "./RenameConfigButton.module.scss";

interface Props {
  children: React.ReactNode;
  config: ImportConfig;
  showHelperText?: boolean;
}

const RenameConfigButton: React.FC<Props> = ({ children, config, showHelperText }) => {
  const [visible, show, hide] = useBoolean();
  return (
    <>
      <span className={styles.container} onClick={show}>
        {children}
      </span>
      {visible && (
        <RenameConfigModal config={config} onHide={hide} showHelperText={showHelperText} />
      )}
    </>
  );
};

export default RenameConfigButton;
